export default function spaceInNumbers(num) {
  return String(num).replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, `$1 `);
}
